import type {ReactNode} from "react";

import {cn} from "@project/design-system-web";

export interface PageContainerSkeletonProps {
  children: ReactNode;
  flush?: boolean;
  className?: string;
}

export function PageContainerSkeleton({
  children,
  className,
  flush = false,
}: PageContainerSkeletonProps) {
  return (
    <div className={cn("@container", "flex h-full min-h-0 flex-1 flex-col")}>
      <div
        className={cn(
          "flex h-full min-h-0 flex-1 flex-col overflow-hidden",
          !flush && "gap-4 p-4 @lg:gap-6 @lg:p-6",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
